/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApplyPricingPolicyCompositesRequest } from '../models/ApplyPricingPolicyCompositesRequest';
import type { CompositeSearchEnhancedFilter } from '../models/CompositeSearchEnhancedFilter';
import type { CutSelectionPolicyParams } from '../models/CutSelectionPolicyParams';
import type { GetApplyPricingPolicyHistoryRequest } from '../models/GetApplyPricingPolicyHistoryRequest';
import type { GetApplyPricingPolicyHistoryResponse } from '../models/GetApplyPricingPolicyHistoryResponse';
import type { GetPolicyExceptionJobsInScopeRequest } from '../models/GetPolicyExceptionJobsInScopeRequest';
import type { GetPolicyExceptionJobsInScopeResponse } from '../models/GetPolicyExceptionJobsInScopeResponse';
import type { PricingPolicy } from '../models/PricingPolicy';
import type { PricingPolicyApplyHistoryStatus } from '../models/PricingPolicyApplyHistoryStatus';
import type { PricingPolicySort } from '../models/PricingPolicySort';
import type { PricingPolicyType } from '../models/PricingPolicyType';
import type { RollupPolicyParams } from '../models/RollupPolicyParams';
import type { WeightingPolicyParams } from '../models/WeightingPolicyParams';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PricingPolicyService {

    /**
     * Create pricing policy
     * @returns PricingPolicy Success
     * @throws ApiError
     */
    public static createPricingPolicy({
        requestBody,
    }: {
        requestBody: {
            name: string;
            type: PricingPolicyType;
            parameters: (CutSelectionPolicyParams | WeightingPolicyParams | RollupPolicyParams);
            description?: string | null;
        },
    }): CancelablePromise<PricingPolicy> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/pricingPolicy',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }

    /**
     * Returns the list of company pricing policies
     * @returns any Success
     * @throws ApiError
     */
    public static getPricingPolicyList({
        requestBody,
    }: {
        requestBody: {
            /**
             * Search name
             */
            search?: string;
            /**
             * Sort options
             */
            sort?: PricingPolicySort;
            /**
             * Policy type
             */
            type?: Array<string>;
            /**
             * Policy enabled state
             */
            enabled?: boolean;
            /**
             * Ignore pagination to fetch all records
             */
            ignorePagination?: boolean;
            /**
             * Pagination Limit
             */
            limit?: number | null;
            /**
             * Pagination Offset
             */
            offset?: number | null;
        },
    }): CancelablePromise<{
        rows: Array<PricingPolicy>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/pricingPolicy/search',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }

    /**
     * Returns the pricing policy
     * @returns PricingPolicy Success
     * @throws ApiError
     */
    public static getPricingPolicy({
        id,
    }: {
        /**
         * Pricing policy id
         */
        id: number,
    }): CancelablePromise<PricingPolicy> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/pricingPolicy/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update pricing policy
     * @returns PricingPolicy Success
     * @throws ApiError
     */
    public static updatePricingPolicy({
        id,
        requestBody,
    }: {
        /**
         * Pricing policy id
         */
        id: number,
        requestBody: {
            name?: string;
            description?: string | null;
            parameters?: (CutSelectionPolicyParams | WeightingPolicyParams | RollupPolicyParams);
            isDefault?: boolean;
            enabled?: boolean;
        },
    }): CancelablePromise<PricingPolicy> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/pricingPolicy/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Deelte the pricing policy
     * @returns any Success
     * @throws ApiError
     */
    public static deletePricingPolicy({
        id,
    }: {
        /**
         * Pricing policy ID
         */
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/pricingPolicy/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Apply pricing policy with filters
     * @returns PricingPolicy Success
     * @throws ApiError
     */
    public static applyPricingPolicy({
        id,
        requestBody,
    }: {
        /**
         * Pricing policy id
         */
        id: number,
        requestBody: ApplyPricingPolicyCompositesRequest,
    }): CancelablePromise<PricingPolicy> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/pricingPolicy/{id}/apply',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Count composites matching filter criteria
     * @returns any Job count result
     * @throws ApiError
     */
    public static countPricingPolicyComposites({
        requestBody,
    }: {
        requestBody: (CompositeSearchEnhancedFilter & {
            paymarketIds: Array<number>;
        }),
    }): CancelablePromise<{
        /**
         * Number of jobs matching the filter criteria
         */
        count?: number;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/pricingPolicy/composites/count',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get pricing policy apply history
     * @returns GetApplyPricingPolicyHistoryResponse Success
     * @throws ApiError
     */
    public static getApplyPricingPolicyHistory({
        requestBody,
    }: {
        requestBody: GetApplyPricingPolicyHistoryRequest,
    }): CancelablePromise<GetApplyPricingPolicyHistoryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/pricingPolicy/applyHistory/get',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }

    /**
     * Resolve the company jobs a policy default exception's criteria select
     * Takes exception criteria and returns the company jobs they select, paginated, plus the matched count and the tenant's total job count for the "X of Y" counter. Criteria are supplied in the body rather than read from a saved exception, so the Applies-to editor can preview a selection the user has not saved yet. Criteria with no values at all select no jobs.
     *
     * @returns GetPolicyExceptionJobsInScopeResponse Success
     * @throws ApiError
     */
    public static getPolicyExceptionJobsInScope({
        requestBody,
    }: {
        requestBody: GetPolicyExceptionJobsInScopeRequest,
    }): CancelablePromise<GetPolicyExceptionJobsInScopeResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/pricingPolicy/jobsInScope',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get pricing policy apply history status
     * @returns PricingPolicyApplyHistoryStatus Success
     * @throws ApiError
     */
    public static getPricingPolicyHistoryStatus({
        id,
    }: {
        /**
         * Pricing policy history id
         */
        id: number,
    }): CancelablePromise<PricingPolicyApplyHistoryStatus> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/pricingPolicy/applyHistory/{id}/status',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
